export const HISTORICAL_TICKET_ORIGIN_PLATFORM = 'HISTORICAL_TICKET_ORIGIN_PLATFORM';
export const HISTORICAL_TICKET_ORIGIN_SIMPLR = 'HISTORICAL_TICKET_ORIGIN_SIMPLR';
